module.exports = __webpack_public_path__ + "static/media/8.bc40e4b5.png";